import UsersTableFilter from "./users-table-filter";
import UsersLogsTableFilter from "./users-logs-table-filter";

const UsersFilters = {
    Table: UsersTableFilter,
    TableLogs: UsersLogsTableFilter,
}

export default UsersFilters;